import { Code, ShoppingCart, Camera, Truck, TrendingUp, Box, Users, Zap } from 'lucide-react';

export const services = [
    {
        title: "Website & eCommerce Development",
        description: "Custom-built, responsive websites and online stores optimized for conversions and user experience.",
        price: "$2,500+",
        icon: Code,
        features: ["Custom WordPress/WooCommerce", "Shopify & Magento Setup", "Mobile-First Design", "Payment Integration"],
        image: "/images/service-ecommerce-new.png"
    },
    {
        title: "Marketplace Management",
        description: "Maximize your sales on Amazon, Flipkart, Walmart, and other marketplaces.",
        price: "$800+ /month",
        icon: ShoppingCart,
        features: ["Amazon Seller/Vendor Central", "Account Optimization", "Product Listing & SEO", "PPC Management"],
        image: "/images/service-marketplace-new.png"
    },
    {
        title: "Product Photography & Editing",
        description: "Professional product photography that increases conversions by showcasing your products in the best light.",
        price: "$50+ /product",
        icon: Camera,
        features: ["Studio & Lifestyle Shots", "360° Product Views", "Professional Editing", "Background Removal"],
        image: "/images/service-photography-new.png"
    },
    {
        title: "Digital Marketing",
        description: "Comprehensive digital marketing strategies to increase visibility and drive targeted traffic.",
        price: "$1,200+ /month",
        icon: TrendingUp,
        features: ["SEO & Local Search", "Google Ads & PPC", "Meta Ads", "Social Media Marketing"],
        image: "/images/service-digital-marketing-new.png"
    },
    {
        title: "Fulfillment & Logistics",
        description: "End-to-end logistics solutions including warehousing, inventory management, and shipping.",
        price: "$500+ /month",
        icon: Truck,
        features: ["Order Processing", "Warehousing", "Shipping Integration", "Returns Management"],
        image: "/images/service-logistics-new.png"
    },
    {
        title: "Inventory & Warehousing",
        description: "Scalable warehousing solutions with real-time inventory tracking and intelligent stock management.",
        price: "$300+ /month",
        icon: Box,
        features: ["Secure Storage", "Real-time Tracking", "Multi-channel Fulfillment", "Stock Alerts"],
        image: "/images/service-inventory-new.png"
    },
    {
        title: "Business Consulting",
        description: "Strategic guidance for business formation, compliance, and growth strategies.",
        price: "$150 /hour",
        icon: Users,
        features: ["Business Formation", "NAICS Code Guidance", "Regulatory Compliance", "Strategy Development"],
        image: "/images/service-consulting-new.png"
    },
    {
        title: "Automation Services",
        description: "Streamline your business processes with custom automation solutions using n8n and Zapier.",
        price: "$1,000+ /project",
        icon: Zap,
        features: ["Workflow Automation", "Custom API Integrations", "Data Sync", "Automated Reporting"],
        image: "/images/service-automation-new.png"
    }
];

export const stats = [
    { label: "Successful Projects", value: "250+" },
    { label: "Revenue Generated", value: "$50M+" },
    { label: "Client Satisfaction", value: "98%" },
    { label: "Avg. Growth Rate", value: "40%" },
];

export const processSteps = [
    {
        number: "1",
        title: "Consultation",
        description: "We understand your business goals, target market, products, and operational challenges to create the right digital strategy."
    },
    {
        number: "2",
        title: "Strategy & Design",
        description: "We plan your website, marketplace setup, branding, and automation workflows with a clear growth-focused structure."
    },
    {
        number: "3",
        title: "Development & Execution",
        description: "Our team develops your website, integrates marketplaces, sets up marketing campaigns, and configures automation systems."
    },
    {
        number: "4",
        title: "Launch, Optimize & Scale",
        description: "We launch your project, track performance, optimize for results, and continuously scale your business with data-driven improvements."
    }
];